import { useEffect } from 'react';

// Contador em nível de módulo (não React state) — permite empilhar modais
// (ex.: diálogo de confirmação por cima de outro modal já aberto) sem que
// fechar um libere o scroll enquanto o outro ainda está na tela.
let contadorModaisAbertos = 0;

// Trava o scroll da página de fundo enquanto um modal está montado (pedido
// do usuário, 13/08/2026: dava pra rolar o conteúdo atrás do modal com o
// scroll do mouse — a tela de fundo deve ficar estática). Chamar sem
// argumento (ou com `true`) no topo de todo componente de modal — como eles
// só ficam montados enquanto abertos, o efeito de montagem já é o gatilho
// certo, sem precisar de um segundo estado "aberto/fechado".
export default function useBloqueioScroll(ativo = true) {
    useEffect(() => {
        if (!ativo) return;
        contadorModaisAbertos += 1;
        if (contadorModaisAbertos === 1) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            contadorModaisAbertos = Math.max(0, contadorModaisAbertos - 1);
            if (contadorModaisAbertos === 0) {
                document.body.style.overflow = '';
            }
        };
    }, [ativo]);
}
